const service = {
    baseAPIURL: 'http://dev.k2btech.com/Services/api/',
    baseImgURL: 'http://dev.k2btech.com/Services/Uploads/',
    localBaseAPIURL: 'http://localhost:50690/api/',
}
export default service